export default defineNuxtRouteMiddleware(async (to) => {
  if (to?.meta.open) {
    return
  }

  // Initialize
  const user = useUserStore()
  await user.init()

  // Redirect to login if necessary
  if (!user.loggedIn) {
    user.redirectTo = to.fullPath
    Notify.error('You need to log in to view this page')
    return navigateTo({ name: 'login' })
  }

  // Load option lists once per session
  const ui = useUiStore()
  await ui.fetchLists()
})
